/**
 * DmPersonaGate — wraps DM routes that require an active DM persona.
 * If the persona is not set, redirects to /dm/users with a redirect param.
 */
import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useDmPersona } from '../context/DmPersonaContext';

export default function DmPersonaGate({ children }) {
  const { isAuthenticated, loading } = useDmPersona();
  const location = useLocation();

  if (loading) {
    return (
      <div className="flex items-center justify-center min-h-[200px]">
        <span className="text-dark-text-secondary text-sm">Loading...</span>
      </div>
    );
  }

  if (!isAuthenticated) {
    const redirectTo = location.pathname + location.search;
    return (
      <Navigate
        to={`/dm/users?redirect=${encodeURIComponent(redirectTo)}`}
        replace
      />
    );
  }

  return children;
}
